// src/pages/EstruturaPage/EstruturaPage.jsx

import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import './EstruturaPage.css';
import { AmenityGallery } from '../../components';

// Importa os ícones e o Swiper para o Lightbox
import { FaTimes } from 'react-icons/fa';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { amenities } from '../../data/amenitiesData';

const EstruturaPage = () => {
    const location = useLocation();
    
    // --- LÓGICA DO LIGHTBOX ADICIONADA ---
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentLightboxImages, setCurrentLightboxImages] = useState([]);
    const [initialSlide, setInitialSlide] = useState(0);

    const openLightbox = useCallback((images, index = 0) => {
        setCurrentLightboxImages(images);
        setInitialSlide(index);
        setLightboxOpen(true);
        document.body.style.overflow = 'hidden';
    }, []);

    const closeLightbox = useCallback(() => {
        setLightboxOpen(false);
        document.body.style.overflow = 'auto';
    }, []);


    // Lógica de scroll para âncora
    useEffect(() => {
        if (location.hash) {
            const sectionId = location.hash.substring(1);
            const section = document.getElementById(sectionId);
            if (section) {
                setTimeout(() => {
                    window.scrollTo({
                        top: section.offsetTop - 100,
                        behavior: 'smooth'
                    });
                }, 100);
            }
        }
    }, [location.hash]);

    return (
        <>
            <div className="structure-page-container">
                <div className="section-header">
                <span className="section-eyebrow">Conforto e Conveniência</span>
                <h1 className="section-title">Ambientes Aconchegantes no Coração da Cidade</h1>
                <p className="section-subtitle">
                    Conheça os espaços do Alzira Plaza, pensados para o seu conforto e conveniência no centro de São Lourenço. Desfrute de nosso elegante hall, relaxe na sala de TV e comece o dia com um autêntico café da manhã mineiro.
                </p>
            </div>
                {amenities.map((item) => (
                    <section key={item.id} id={item.id} className="amenity-block">
                        <div className="amenity-block-image" onClick={() => openLightbox(item.images, 0)}>
                            <AmenityGallery images={item.images} title={item.name} />
                        </div>
                        <div className="amenity-block-text">
                            <h3>{item.name}</h3>
                            <p>{item.description}</p>
                        </div>
                    </section>
                ))}

                     <div className="final-cta-section">
        <h2>Pronto para Viver esta Experiência?</h2>
        <p>Garanta sua data em um dos melhores hotéis de São Lourenço.</p>
        <a href="https://wa.me/+5535988179138" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
          Fazer Reserva Agora
        </a>
      </div>
            </div>

       

            {/* --- JSX DO LIGHTBOX ADICIONADO --- */}
            {lightboxOpen && (
                <div className="lightbox-overlay" onClick={closeLightbox}>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <button className="lightbox-close" onClick={closeLightbox}><FaTimes /></button>
                        <div className="lightbox-swiper-container">
                            <Swiper
                                modules={[Navigation, Pagination, A11y]}
                                navigation
                                pagination={{ type: 'fraction' }}
                                loop={true}
                                initialSlide={initialSlide}
                                className="lightbox-swiper"
                            >
                                {currentLightboxImages.map((img, index) => (
                                    <SwiperSlide key={index}>
                                        <img src={img} alt={`Imagem ${index + 1}`} className="lightbox-image"/>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default EstruturaPage;